/* istanbul ignore file */

import type { AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';

import { API_ENDPOINT as baseURL, API_TIMEOUT as timeout } from 'src/settings';
import { getSession } from './getSession';

export const MISSING_ID_TOKEN = 'ID Token missing from user session';

const axiosConfig: AxiosRequestConfig = {
  baseURL,
  timeout,
  headers: { 'Content-Type': 'application/json' },
};

export const apiCall = axios.create(axiosConfig);

export const authenticatedApiCall = axios.create(axiosConfig);

authenticatedApiCall.interceptors.request.use(async (config) => {
  const session = await getSession();
  const idToken = session?.idToken.jwtToken;

  if (!idToken) {
    throw new Error(MISSING_ID_TOKEN);
  }

  if (config.headers == null) {
    config.headers = {} as AxiosRequestHeaders;
  }

  config.headers['x-id-token'] = idToken;

  return config;
});
